import { Component, ViewChild, ElementRef, AfterViewInit, OnDestroy } from "@angular/core";
import { RenderContext } from "../webgl/webgl-context";
import { ShaderProgram } from "../webgl/webgl-program";
import { RenderBatch } from "../render/render-batch";
import { Messenger } from "../worker/messenger";
import { InputManager } from "./input-manager";
var CanvasComponent = (function () {
    function CanvasComponent(gl_, program_, input_manager_, messenger_, render_batch_) {
        var _this = this;
        this.gl_ = gl_;
        this.program_ = program_;
        this.input_manager_ = input_manager_;
        this.messenger_ = messenger_;
        this.render_batch_ = render_batch_;
        this.fallback_text = "Loading Canvas...";
        this.RENDER_OBJECTS = 3;
        this.model_changes_ = new Float32Array(this.RENDER_OBJECTS * 16);
        this.tick = function (timestamp) {
            _this.cancel_token_ = requestAnimationFrame(_this.tick);
            var inputs = _this.input_manager_.current_state;
            inputs.aspect = _this.canvas_width / _this.canvas_height;
            _this.messenger_.sendInputs(inputs);
            _this.input_manager_.update();
            var view = _this.model_changes_.subarray(0, 16);
            var projection = _this.model_changes_.subarray(16, 32);
            _this.render(view, projection);
        };
        this.messenger_.getChanges().subscribe(function (array) {
            _this.model_changes_.set(array);
        });
    }
    Object.defineProperty(CanvasComponent.prototype, "canvas_width", {
        get: function () {
            return this.canvas_ref.nativeElement.clientWidth;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(CanvasComponent.prototype, "canvas_height", {
        get: function () {
            return this.canvas_ref.nativeElement.clientHeight;
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    CanvasComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var gl = this.gl_.create(this.canvas_ref.nativeElement);
        if (gl) {
            this.program_.initWebGl();
            var game_objects = ["cube_low"];
            this.render_batch_.start(game_objects);
            this.cancel_token_ = requestAnimationFrame(this.tick);
        }
        else {
            setTimeout(function () {
                _this.fallback_text = "Unable to initialise WebGL.";
            }, 0);
        }
    };
    CanvasComponent.prototype.render = function (view, projection) {
        var gl = this.gl_.context;
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
        gl.uniformMatrix4fv(this.program_.uView, false, view);
        gl.uniformMatrix4fv(this.program_.uProjection, false, projection);
        this.render_batch_.drawAll(this.model_changes_);
    };
    ;
    CanvasComponent.prototype.ngOnDestroy = function () {
        cancelAnimationFrame(this.cancel_token_);
        localStorage.clear();
    };
    CanvasComponent.decorators = [
        { type: Component, args: [{
                    selector: 'main-canvas',
                    template: "\n    <canvas id=\"canvas\" #canvas canvas-controller [width]=\"canvas_width\" [height]=\"canvas_height\">\n        <p>{{fallback_text}}</p>\n    </canvas>\n    ",
                    styles: ["\n    #canvas {\n        height: 100%;\n        width: 100%;\n        border: none;\n        position: absolute;\n        z-index: 0;\n    }\n    "]
                },] },
    ];
    CanvasComponent.ctorParameters = function () { return [
        { type: RenderContext, },
        { type: ShaderProgram, },
        { type: InputManager, },
        { type: Messenger, },
        { type: RenderBatch, },
    ]; };
    CanvasComponent.propDecorators = {
        "canvas_ref": [{ type: ViewChild, args: ["canvas",] },],
    };
    return CanvasComponent;
}());
export { CanvasComponent };
//# sourceMappingURL=canvas.component.js.map